import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20nodes%20and%20connections%20on%20a%20dark%20warm%20amber%20gradient%20background%2C%20geometric%20data%20flow%20lines%2C%20modern%20technology%20concept%2C%20clean%20minimal%20style%2C%20soft%20glowing%20particles%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20terracotta%20tones%2C%20futuristic%20yet%20elegant%20abstract%20composition%2C%20no%20text%2C%20no%20human%20faces&width=1800&height=900&seq=hero-bg-2025&orientation=landscape"
          alt="种子搜索背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold font-heading text-white mb-4 leading-tight">
          种子搜索 — 快速找到你需要的资源
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-[600px] mx-auto leading-relaxed">
          最高效的BT资源检索工具，支持影视、音乐、软件等全类型资源搜索，海量数据库实时更新，精准匹配每一次搜索需求
        </p>

        <div className="relative max-w-[640px] mx-auto">
          <div className="flex items-center bg-white rounded-xl overflow-hidden shadow-lg ring-1 ring-white/20">
            <div className="flex items-center gap-2 pl-5 pr-2 py-3.5">
              <i className="ri-search-line text-lg text-foreground-400"></i>
            </div>
            <input
              type="text"
              placeholder="输入关键词搜索资源..."
              className="flex-1 py-3.5 pr-4 text-sm text-foreground-900 bg-transparent outline-none placeholder:text-foreground-400"
            />
            <Link
              to="/category/movie"
              className="mr-1.5 px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              搜索资源
            </Link>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
          <span className="text-xs text-white/60">热门搜索：</span>
          {['最新电影', '无损音乐', '开源软件', '独立游戏'].map((tag) => (
            <Link
              key={tag}
              to="/category/movie"
              className="px-3 py-1 text-xs text-white/80 bg-white/10 rounded-full hover:bg-white/20 transition-all whitespace-nowrap"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}